import { ScoUserSearchDraft } from '@src/graphql-types'

export const defaultPrimarySkillTitles: string[] = [
  'Advertising',
  'Design',
  'Engineering',
  'Funding',
  'Hiring',
  'Legal',
  'Marketing',
  'Product',
  'Sales',
  'Strategy',
]

export const ctaVariants: {
  [key: string]: {
    signupButtonLabel: (userSearchDraft: Partial<ScoUserSearchDraft>) => string
    submitButtonLabel: (userSearchDraft: Partial<ScoUserSearchDraft>) => string
  }
} = {
  default: {
    signupButtonLabel: () => 'Register & See My Matches',
    submitButtonLabel: () => 'See My Matches',
  },
  alt: {
    signupButtonLabel: (userSearchDraft: ScoUserSearchDraft) =>
      `See My ${userSearchDraft?.matchedUsersCount} Matches`,
    submitButtonLabel: (userSearchDraft: ScoUserSearchDraft) =>
      `See My ${userSearchDraft?.matchedUsersCount} Matches`,
  },
}

export const generatePrompt = ({ userRoleKeys, selectedSkillTitles }) => {
  const parts = []

  if (userRoleKeys.length === 0 && selectedSkillTitles.length === 0) {
    return ''
  }

  parts.push('Looking')

  switch (userRoleKeys[0]) {
    case 'advisor':
      parts.push('for an **advisor**')
      if (selectedSkillTitles.length > 0) {
        parts.push('who can help with')
      }
      break
    case 'cofounder':
      parts.push('for a **co-founder**')
      if (selectedSkillTitles.length > 0) {
        parts.push('who knows about')
      }
      break
    case 'peer':
      parts.push('to meet **founder peers**')
      if (selectedSkillTitles.length > 0) {
        parts.push('who know about')
      }
      break
    case 'talent':
      parts.push('to hire **talent**')
      if (selectedSkillTitles.length > 0) {
        parts.push('who can work on')
      }
      break
    case 'service-provider':
      parts.push('to hire a **service provider**')
      if (selectedSkillTitles.length > 0) {
        parts.push('who can work on')
      }
      break
    default:
      parts.push('for someone')
      if (selectedSkillTitles.length > 0) {
        parts.push('who knows about')
      }
      break
  }

  if (selectedSkillTitles.length > 0) {
    parts.push(selectedSkillTitles.map(s => `**${s}**`).join(', '))
  }

  let firstSentence = parts.join(' ')
  if (firstSentence) {
    firstSentence += '.'
  }

  return [firstSentence].filter(Boolean).join(' ')
}
